import { Component } from 'preact';

class Mouse extends Component {
	getSizes(e) {
		const { width, height, left, top } = e.target.getBoundingClientRect();

		this.setState({
			width,
			height,
			top,
			left
		});
	}

	handleMouseMove(e) {
		this.setState({
			x: e.clientX - this.state.left,
			y: e.clientY - this.state.top
		});
	}

	constructor(props) {
		super(props);
		this.handleMouseMove = this.handleMouseMove.bind(this);
		this.getSizes = this.getSizes.bind(this);
		this.state = { x: 25, y: 25, height: 100, width: 100 };
	}

	render() {
		const { className } = this.props;

		return (
			<div
				className={className}
				onMouseMove={this.handleMouseMove}
				onMouseEnter={this.getSizes}
				ref={elem => (this.elem = elem)}
			>
				{this.props.render({
					...this.state
				})}
			</div>
		);
	}
}

export default Mouse;



// WEBPACK FOOTER //
// ./components/MouseTracker/index.js